export default "__VITE_ASSET__c730c3a3__"